import request from '../utils/request'

export function selectSocialList(data) {
  return request({
    url: '/api/social/list',
    method: 'post',
    data,
  })
}
